import { ReferenciaExpediente } from '@/Domain/Expediente'

export class FetchDetailsExpedienteCommand {
  private _referencia!: ReferenciaExpediente

  constructor (referencia: ReferenciaExpediente) {
    this._referencia = referencia
  }

  referencia (): ReferenciaExpediente {
    return this._referencia
  }
}
